import { NavigateOptions, useHref, useNavigate } from "react-router";
import { HeroUIProvider, ToastProvider } from "@heroui/react";
import { ThemeProvider } from "next-themes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { TOAST_TIMEOUT } from "./config/constants";
import { Routes } from "./routes";
import { AppStatusHandler } from "./app/handlers/AppStatusHandler";
import { AppBootstrapHandler } from "./app/handlers/AppBootstrapHandler";
import { SwipeBackHandler } from "./app/handlers/SwipeBackHandler";
import { StoreHandler } from "./app/handlers/StoreHandler";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

declare module "@react-types/shared" {
  interface RouterConfig {
    routerOptions: NavigateOptions;
  }
}

export function App() {
  const navigate = useNavigate();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="class">
        <HeroUIProvider navigate={navigate} useHref={useHref}>
          <AppBootstrapHandler />
          <SwipeBackHandler />
          <ToastProvider toastProps={{ timeout: TOAST_TIMEOUT }} />
          <AppStatusHandler>
            <StoreHandler>
              <Routes />
            </StoreHandler>
          </AppStatusHandler>
        </HeroUIProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
